import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

class Footer extends Component {
	render() {
		return (
			<div>
				<footer className="footer stick-footer">
					<div className="columns">
						<div className="column ">
							<Fade left>
								<h3>Navigation</h3>
							</Fade>
							<hr />
							<Fade left cascade>
								<ul>
									<li> <Link to="/registrasi"  >Daftar</Link> </li>
									<li> <Link to="/layanan"  >Layanan</Link> </li>
									<li><Link to="/privasi"  >Kebijakan Privasi</Link> </li>
								</ul>
							</Fade>
						</div>
						<div className="column ">
							<Fade bottom>
								<h3>Informasi</h3>
							</Fade>
							<hr />
							<Fade bottom cascade>
								<ul>
									<li><Link to="/#review"  >Tentang</Link></li>
									<li>Konsumen</li>
									<li>Mitra Driver</li>
								</ul>
							</Fade>
						</div>
						<div className="column ">
							<Fade right>
								<h3>Sumber</h3>
							</Fade>
							<hr />
							<Fade right cascade>
								<ul>
									<li><Link to="/kontak"  >Kontak</Link></li>
									<li><a href="https://blog.deliv.co.id">Blog</a></li>
								</ul>
							</Fade>
						</div>
					</div>
					<div className="columns has-text-centered is-centered">
						<div className="column  is-6 company-info ">
							<Fade bottom>
								<p>
									This website and its content is copyright of Deliv Corp - © Deliv Corp 2018. All
									rights reserved.
								</p>
							</Fade>
						</div>
					</div>
					<div className="columns has-text-centered is-centered">
						<div className="column  is-6 company-info ">
							<Fade bottom>
								<a href="https://www.facebook.com/Deliv.Indonesia/">
								<FontAwesomeIcon
										icon={['fab','facebook']}  className="icon is-medium"
									/>
								</a>
								<a href="https://www.twitter.com/">
								<FontAwesomeIcon
										icon={['fab','twitter']} className="icon is-medium"
									/>
								</a>
								<a href="https://www.instagram.com/deliv.id">
								<FontAwesomeIcon
										icon={['fab','instagram']} className="icon is-medium"
									/>
								</a>
								<a href="https://www.linkedin.com/">
								<FontAwesomeIcon
										icon={['fab','linkedin']} className="icon is-medium"
									/>
								</a>
								<a href="https://www.youtube.com/">
									<FontAwesomeIcon
										icon={['fab','youtube']} className="icon is-medium"
									/>
								</a>
							</Fade>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}

export default Footer;
